import PageBrandMapView from '@pages/seller-page-brand/map/views/PageBrandMapView.vue';
import { piniaPageBrand } from '@stores/usePageBrandStore';
import { createApp } from 'vue';

export const initMap = (): void => {
  createApp(PageBrandMapView)
    .use(piniaPageBrand)
    .mount('#brand-details-map-app');
};
